import { VueModule } from '@Foundation/utilities';
import productPopin from './code/Scripts/components/product-popin/product-popin.vue';

export default VueModule({
  components: {
    productPopin,
  },
});
